import React from 'react';
import SalonBookingForm from './SalonBookingForm';

// Deprecated split route — kept as a working alias so old bookmarks still open
// the unified New Booking / Invoice page.
export default function QuickInvoicePage() {
  return <SalonBookingForm />;
}
